/** @format */

import {
	AppProductReviewState,
	ReviewSummary,
	selectProductReviewSummary
} from '@product-reviews/data-access';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'product-reviews-percentage',
    templateUrl: './reviews-percentage.component.html',
    standalone: false
})
export class ReviewsPercentageComponent implements OnInit, OnDestroy {
	percentage: number;

	private UNSUBSCRIBE$ = new Subject<void>();

	percentage$ = this.store.select(selectProductReviewSummary).pipe(takeUntil(this.UNSUBSCRIBE$));

	constructor(private store: Store<AppProductReviewState>) {}

	ngOnInit() {
		this.percentage$.subscribe((reviewSummary: ReviewSummary) => {
			if (reviewSummary) {
				this.percentage = reviewSummary.recommendationPercentage;
			}
		});
	}

	ngOnDestroy() {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}
